const accessTokenKey = 'situation_center_access_token'

export function setAccessToken(token) {
	return localStorage.setItem(accessTokenKey, token)
}

export function getAccessToken() {
	return localStorage.getItem(accessTokenKey)
}

export function removeAccessToken() {
	return localStorage.removeItem(accessTokenKey)
}